export const URL_PARAM = { isIFrame: "isIFrame",
    data:"data"
 };
